import {Box, Stack} from '@mui/material';
import ArrButton from '../../../common/arr-button/ArrButton';
import {t} from 'i18next';

const ProtocolIntelligenceFallback = ({
  onRefreshClick,
}: {
  onRefreshClick: () => void;
}) => {
  const handleRefreshClick = () => {
    onRefreshClick();
  };

  return (
    <Stack
      className="manage-protocol-fallback-content-body"
      data-testid="Protocol-Intelligence-Fallback"
    >
      <Box
        className="manage-protocol-fallback-content-body-heading"
        aria-label={t('ai.review.protocolIntelligence.fallback.heading')}
      >
        {t('ai.review.protocolIntelligence.fallback.heading')}
      </Box>
      <Box
        className="manage-protocol-fallback-content-body-description"
        aria-label={`${t('ai.review.protocolIntelligence.fallback.description-1')}${t('ai.review.protocolIntelligence.fallback.description-2')}`}
        data-testid="Protocol-Intelligence-Fallback-Description"
      >
        {t('ai.review.protocolIntelligence.fallback.description-1')}
        <br />
        {t('ai.review.protocolIntelligence.fallback.description-2')}
      </Box>
      <ArrButton
        size="medium"
        dataTestId="Refresh-protocol-Api-Data"
        onClick={handleRefreshClick}
      >
        {t('ai.review.protocolIntelligence.fallback.refresh')}
      </ArrButton>
    </Stack>
  );
};

export default ProtocolIntelligenceFallback;
